import React from "react";
import { connect } from "react-redux";
import { Flex } from "/app/src/component";
import FAQAddNewQuestion from "./AddNewQuickResponse";
import QuickResponseModel from "/app/src/model/QuickResponse/model";
import * as QuickResponseSelectors from "/app/src/model/QuickResponse/selector";
import style from "./style.css";
import Item from "./Item/Item";

class QuickResponse extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchInput: "",
    };
    this._searchInputHandler = this._searchInputHandler.bind(this);
    this._renderList = this._renderList.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(QuickResponseModel.read());
  }

  __getIndex(id) {
    const qr = this.props.quickResponses;
    const len = qr.size;
    for (var i = 0; i < len; i++) {
      if (qr.get(i).id === id) return i;
    }
  }

  _renderList() {
    const ListComponents = [];
    this.props.quickResponses.toJS().forEach((qr) => {
      ListComponents.push(
        <Item
          title={!qr.title ? "Saknar titel" : qr.title}
          body={qr.quick_response}
          id={qr.id}
          key={qr.id}
          currentItem={this.state.itemSelected}
          searchInput={this.state.searchInput}
        />
      );
    });
    return ListComponents;
  }
  _searchInputHandler(event) {
    this.setState({ searchInput: event.target.value });
  }
  render() {
    return (
      <Flex column grow>
        <Flex width="100%" className={style.FAQSearch} basis="70px">
          <input
            onChange={this._searchInputHandler}
            value={this.searchInput}
            placeholder="Sök bland Snabbsvar..."
            className={style.FAQSearchInput}
          />
        </Flex>

        <Flex column className={style.FAQItemList} grow>
          <div
            style={{
              overflow: "auto",
              flexGrow: 1,
            }}
          >
            <FAQAddNewQuestion currentItem={this.state.itemSelected} />

            {this._renderList()}
          </div>
        </Flex>
      </Flex>
    );
  }
}

function mapStateToProps(state, props) {
  const quickResponses = QuickResponseSelectors.getQuickResponses(state);
  return {
    quickResponses: quickResponses,
  };
}
export default connect(mapStateToProps, null)(QuickResponse);



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ChatSettings/QuickResponse/index.js